/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-08-02 10:54:46
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2021-08-12 16:35:48
 */
import request from "@/utils/request";
const requestUrl = `${window.env.scimSystem}/api/v1`;
const api = {
  // 列表
  getList: params => request({
    url: `${requestUrl}/tenant/page`,
    method: "get",
    params
  }),
  // 弹窗-客户查询
  searchCustom: params => request({
    url: `${requestUrl}/tenant/platform`,
    method: "get",
    params
  }),
  // 同步客户
  ayncCustom: data => request({
    url: `${requestUrl}/tenant/platform`,
    method: "post",
    data
  }),
  // 菜单tree
  getMenuTree: params => request({
    url: `${requestUrl}/system/menu/tree`,
    method: "get",
    params
  }),
  // 根据客户查询对应角色
  getCustomRole: id => request({
    url: `${requestUrl}/system/tenant/${id}/role-id`,
    method: "get",
    params: {}
  }),
  // 根据客户角色查询对应菜单
  getCustomRoleMenu(params) {
    return request({
      url: `${requestUrl}/menus`,
      method: "get",
      params
    });
  },

  /**
   * @description: 保存角色菜单权限
   * @param {*} id，角色id
   * @param {*} ids
   * @return {*}
   */
  saveCustomRole(id, ids) {
    for (let i = 0; i < ids.length; i++) {
      if (ids[i].length === 0) {
        ids.splice(i, 1);
      }
    }
    const data = {
      operation: "REPLACE",
      keys: ids
    };
    return request({
      url: `${requestUrl}/tenant/${id}/menu`,
      method: "PATCH",
      data
    });
  },
  // 根据租户查找分配菜单
  getMenuByTenantId: (id, params) => request({
    url: `${requestUrl}/tenant/${id}/menu`,
    method: "get",
    params
  }),
  // 创建组织
  createOrg: params => request({
    url: `${requestUrl}/tenant`,
    method: "post",
    data: params
  }),
  // 获取组织
  getOrgDesc: id => request({
    url: `${requestUrl}/tenant/${id}`,
    method: "get"
  }),
  updateOrg: params => request({
    url: `${requestUrl}/tenant`,
    method: "put",
    data: params
  }),
  updateOrgEffect: params => request({
    url: `${requestUrl}/tenant/effect`,
    method: "put",
    data: params
  }),
  getUsersByOrg: params => request({
    url: `${requestUrl}/tenant/${params.id}/users`,
    method: "get",
    params
  }),
  allotUserToOrg: params => request({
    url: `${requestUrl}/tenant/shareOtherOrg`,
    method: "put",
    params
  })
};

export default api;
